import React from 'react';
import ReactDOM from 'react-dom/client';
import Header from './header/header.js'
import FeaturedProducts from './featured-products/featuredproducts.js' 
import Aboutus from './about-us/aboutus.js' 
import HowItWorks from './howItWorks/howItWorks.js' 
import CustomerReview from './customerReview/customerReview.js'
import Footer from './footer/footer.js'
import './index.css';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <Header />
   <FeaturedProducts />
   <HowItWorks />
   <Aboutus />
   <CustomerReview />
   <Footer />
  </React.StrictMode>
);

reportWebVitals();
